import React, { useRef } from 'react';
import { HomeworkItem } from '@homework-app/shared';

interface HomeworkItemProps {
  item: HomeworkItem;
  onUpdateHomework: (id: string, text: string, completed: boolean) => void;
  onDeleteHomework: (id: string) => void;
  onPhotoUpload: (homeworkId: string, file: File) => void;
  onPhotoClick: (photoSrc: string) => void;
}

const HomeworkItemComponent: React.FC<HomeworkItemProps> = ({
  item,
  onUpdateHomework,
  onDeleteHomework,
  onPhotoUpload,
  onPhotoClick
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const toggleComplete = () => {
    onUpdateHomework(item.id, item.text, !item.completed);
  };

  const updateText = (text: string) => {
    onUpdateHomework(item.id, text, item.completed);
  };

  const deleteItem = () => {
    onDeleteHomework(item.id);
  };

  const handlePhotoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onPhotoUpload(item.id, file);
    }
    // Reset input so same file can be uploaded again if needed
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div className="homework-item-wrapper">
      <div className={`homework-item ${item.completed ? 'completed' : ''}`}>
        <input
          type="checkbox"
          checked={item.completed}
          onChange={toggleComplete}
        />
        <input
          type="text"
          className="homework-text"
          value={item.text}
          onChange={(e) => updateText(e.target.value)}
          placeholder="Enter homework..."
        />
        <label className="photo-upload-btn">
          📷
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handlePhotoUpload}
          />
        </label>
        <button className="delete-btn" onClick={deleteItem} title="Delete homework">
          🗑️
        </button>
      </div>

      {item.photos && item.photos.length > 0 && (
        <div className="photo-preview">
          {item.photos.map((photo, index) => (
            <img
              key={photo.id || index}
              src={photo.url}
              alt="Homework photo"
              onClick={() => onPhotoClick(photo.url)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HomeworkItemComponent;